module.exports = __webpack_public_path__ + "img/base_activites_surf.9d2b78e8.svg";